import { MultiSelect, type MultiSelectProps } from "@mantine/core"
import { useSelectCreatable } from "./SelectCreatable"

export function MultiSelectCreatable({ data, ...props }: MultiSelectProps) {
  const { data: selectData, search, setSearch } = useSelectCreatable(data as string[])

  return <MultiSelect {...props} data={selectData} searchable searchValue={search} onSearchChange={setSearch} />
}
